module.exports = __webpack_public_path__ + "static/media/upload.9f5ff2f7.svg";